export default __webpack_public_path__ + "static/media/error-mail.363eaa6c.svg";